import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError, LOGO_ICON } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(f.email, f.password); toast.success("Benvenuto!"); nav("/dashboard"); }
    catch (e) { toast.error(formatApiError(e)); }
    setLoading(false);
  };
  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md ic-card p-8">
        <div className="flex justify-center mb-4"><img src={LOGO_ICON} alt="ImpresaChiara" className="w-14 h-14 rounded-xl" /></div>
        <h1 className="text-2xl font-bold text-center">Bentornato</h1>
        <p className="text-center text-sm text-[#524F5E] mt-1">Accedi al tuo cruscotto</p>
        <button onClick={googleLogin} data-testid="google-login-btn" className="mt-6 w-full ic-btn-ghost flex items-center justify-center gap-2">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continua con Google
        </button>
        <div className="my-5 flex items-center gap-3 text-xs text-[#7A7788]"><div className="flex-1 h-px bg-[#E5E4EB]" />oppure<div className="flex-1 h-px bg-[#E5E4EB]" /></div>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required placeholder="Email" value={f.email} onChange={e => setF({...f, email: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB] focus:border-[#5424D5] focus:outline-none" data-testid="login-email" />
          <input type="password" required placeholder="Password" value={f.password} onChange={e => setF({...f, password: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB] focus:border-[#5424D5] focus:outline-none" data-testid="login-password" />
          <button type="submit" disabled={loading} className="w-full ic-btn-primary" data-testid="login-submit">{loading ? "Accesso…" : "Accedi"}</button>
        </form>
        <p className="text-center text-sm text-[#524F5E] mt-5">Nuovo su ImpresaChiara? <Link to="/register" className="text-[#5424D5] font-semibold">Registrati</Link></p>
      </div>
    </div>
  );
}

export function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await register(f.email, f.password, f.name, { terms_version: "tos_v1_2026-09" }); toast.success("Account creato!"); nav("/dashboard"); }
    catch (e) { toast.error(formatApiError(e)); }
    setLoading(false);
  };
  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md ic-card p-8">
        <div className="flex justify-center mb-4"><img src={LOGO_ICON} alt="ImpresaChiara" className="w-14 h-14 rounded-xl" /></div>
        <h1 className="text-2xl font-bold text-center">Inizia gratis</h1>
        <p className="text-center text-sm text-[#524F5E] mt-1">Nessuna carta richiesta.</p>
        <button onClick={googleLogin} data-testid="google-register-btn" className="mt-6 w-full ic-btn-ghost flex items-center justify-center gap-2">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continua con Google
        </button>
        <div className="my-5 flex items-center gap-3 text-xs text-[#7A7788]"><div className="flex-1 h-px bg-[#E5E4EB]" />oppure<div className="flex-1 h-px bg-[#E5E4EB]" /></div>
        <form onSubmit={submit} className="space-y-3">
          <input required placeholder="Nome" value={f.name} onChange={e => setF({...f, name: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB] focus:border-[#5424D5] focus:outline-none" data-testid="register-name" />
          <input type="email" required placeholder="Email" value={f.email} onChange={e => setF({...f, email: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB] focus:border-[#5424D5] focus:outline-none" data-testid="register-email" />
          <input type="password" required minLength={6} placeholder="Password (min. 6 caratteri)" value={f.password} onChange={e => setF({...f, password: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E5E4EB] focus:border-[#5424D5] focus:outline-none" data-testid="register-password" />
          <label className="flex items-start gap-2 text-xs text-[#524F5E] mt-3">
            <input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} className="mt-0.5" data-testid="register-consent" />
            <span>Ho letto e accetto i <Link to="/termini" className="text-[#5424D5] font-semibold">Termini di servizio</Link> e la <Link to="/privacy" className="text-[#5424D5] font-semibold">Privacy Policy</Link>.</span>
          </label>
          <button type="submit" disabled={loading || !consent} className="w-full ic-btn-primary" data-testid="register-submit">{loading ? "Creazione…" : "Crea account"}</button>
        </form>
        <p className="text-center text-sm text-[#524F5E] mt-5">Hai già un account? <Link to="/login" className="text-[#5424D5] font-semibold">Accedi</Link></p>
      </div>
    </div>
  );
}

export function AuthCallbackPage() {
  const nav = useNavigate();
  const ran = React.useRef(false);
  React.useEffect(() => {
    if (ran.current) return; ran.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    (async () => {
      try {
        const api = (await import("@/lib/api")).default;
        await api.post("/auth/google/session", { session_id: m[1] });
        window.history.replaceState(null, "", "/dashboard");
        window.location.href = "/dashboard";
      } catch (e) {
        toast.error("Login Google fallito");
        nav("/login");
      }
    })();
  }, [nav]);
  return <div className="min-h-screen flex items-center justify-center">Autenticazione in corso…</div>;
}
